(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[975],{

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 36484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckContent; }
/* harmony export */ });
/* harmony import */ var _Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59699);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CheckContent(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "mt-2 flex items-start first:mt-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__/* .FaCheckCircle */ .F, {
        size: 16,
        className: "mr-2 mt-1 text-bbc-brand-600"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      dangerouslySetInnerHTML: {
        __html: data
      },
      className: ""
    })]
  });
}

/***/ }),

/***/ 59699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FaCheckCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheckCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66865);
/* harmony import */ var components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78762);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/** ========== */




var FormCountry = function FormCountry(_ref) {
  var country_id = _ref.country_id;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_3__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country_id;

                try {
                  (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/question"),
                    data: dataSend,
                    token: token
                  }).then(function (res) {
                    if (res.state) {
                      (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", dataSend, "Contact form");
                      openAlert(2000, "success");
                      reset();
                    } else {
                      openAlert(3000, "error");
                      console.log("error");
                    }
                  })["catch"](function (e) {
                    openAlert(3000, "error");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        register: register,
        errors: errors,
        name: "first_name",
        placeholder: "Name*",
        requiredText: "Name is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputEmail */ .j7, {
        register: register,
        errors: errors
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        as: "textarea",
        register: register,
        errors: errors,
        name: "message",
        placeholder: "Message*",
        requiredText: "Message is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "flex flex-wrap items-center justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 mb-6 text-center lg:col-auto  lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "inline-block",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: recaptchaRef,
            className: "mx-auto w-max"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 text-center lg:col-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          type: "submit",
          style: {
            minWidth: "170px"
          },
          disabled: isSubmitting,
          children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__/* .BiLoaderAlt */ .s, {
            className: "mr-2 inline-block animate-spin",
            size: 20
          }), "Send Your Message"]
        })
      })]
    })]
  });
};
/** ========== */


var FormCountries = function FormCountries(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      descriptionClass = _ref3.descriptionClass,
      contentBottom = _ref3.contentBottom,
      country_id = _ref3.country_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: "rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]",
    style: {
      boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormCountry, {
        country_id: country_id
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      children: contentBottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormCountries);
FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {}
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 58720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77450);
/* harmony import */ var components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59699);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function LeftContentChildren(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: "mb-6 lg:mb-0",
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "mt-2 flex items-start first:mt-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_7__/* .FaCheckCircle */ .F, {
            size: 16,
            className: "mr-2 mt-1 text-bbc-brand-600"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: item
          },
          className: ""
        })]
      }, index);
    })
  });
}

var LeftContentChildrenWithNote = function LeftContentChildrenWithNote(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContentChildren, {
      data: data.content
    }), data.note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "mt-2 mb-6 rounded bg-[#F1FBFF] py-2 px-4 text-sm font-normal italic text-bbc-brand-800 lg:mb-0",
      dangerouslySetInnerHTML: {
        __html: data.note
      }
    })]
  });
};

var LeftSliderChildren = function LeftSliderChildren(_ref3) {
  var data = _ref3.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("DESKTOP"),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(setScreen);
  var swiper = {
    preloadImages: false,
    lazy: true,
    allowTouchMove: false,
    navigation: {
      nextEl: ".slider-button-next",
      prevEl: ".slider-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 50
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: screen === "DESKTOP" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, _objectSpread(_objectSpread({
        className: "",
        modules: [swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_]
      }, swiper), {}, {
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContentChildrenWithNote, {
              data: item
            })
          }, index);
        })
      }))
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "hidden h-fit w-full space-y-2 rounded-xl bg-transparent py-0 px-4 text-bbc-brand-700",
      children: data.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContentChildren, {
            data: item.content
          })
        }, index);
      })
    })
  });
};

var LeftContent = function LeftContent(_ref4) {
  var data = _ref4.data,
      description = _ref4.description,
      title = _ref4.title,
      dataJson = _ref4.dataJson;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: " lg:shadow-bbc h-full w-full rounded-xl bg-transparent py-0 px-4 text-bbc-brand-800  lg:bg-white lg:p-8 ",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "mb-3",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
        className: " relative bg-gradient-to-t from-[#9845E8] via-[#5b4fc4] to-[#33D2FF] bg-clip-text text-lg font-semibold text-transparent before:absolute before:bottom-0 before:left-0 before:block before:h-[1px] before:w-full  before:origin-top-left before:bg-gradient-to-r before:transition  before:content-['']  lg:text-2xl ",
        children: "Benefit"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      className: "mb-6 text-bbc-30px font-semibold lg:text-bbc-40px",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      children: [(description === null || description === void 0 ? void 0 : description.length) > 0 && (description === null || description === void 0 ? void 0 : description.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
          className: "mb-2",
          children: item
        }, index);
      })), Array.isArray(data) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
        children: Object.keys(data[0]).length > 0 && typeof data[0] !== "string" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftSliderChildren, {
          data: data
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContentChildren, {
          data: data
        })
      }), dataJson.left_note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "mt-2 rounded bg-[#F1FBFF] py-2 px-4 text-sm font-normal italic text-bbc-brand-800",
        dangerouslySetInnerHTML: {
          __html: dataJson.left_note
        }
      })]
    })]
  });
};

var ListRegulation = function ListRegulation(_ref5) {
  var data = _ref5.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: "flex flex-1 flex-wrap bg-bbc-brand-100 py-10 px-2",
    children: data.map(function (service, serviceIdx) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "w-1/2 text-center ".concat(serviceIdx % 2 === 0 ? "pr-3" : "pl-3", " ").concat(serviceIdx < data.length - 2 ? "mb-4" : ""),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          src: "/assets/icons/".concat(service.icon),
          width: 48,
          height: 48,
          alt: "icon",
          wrapper: {
            className: "block flex justify-center mb-[15px] h-12"
          }
        }), service.title]
      }, serviceIdx);
    })
  });
};

var RegulationCard = function RegulationCard(_ref6) {
  var data = _ref6.data,
      item = _ref6.item,
      index = _ref6.index;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: " flex h-full flex-col lg:mt-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: "mb-6 flex ".concat(index > 0 ? "flex-row-reverse" : ""),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: "text-2xl font-semibold leading-9 text-bbc-brand-700 ".concat(data.length > 1 ? "w-full lg:w-4/5 " : "w-full", " "),
        children: item.title
      }), data.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "".concat(index > 0 ? "slider-button-prev text-left" : "slider-button-next text-right", " hidden w-1/5 lg:block"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
          // Id={"btn-" + index}
          className: "shadow-bbc rounded-full p-3 ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            src: "/assets/icons/arrow.svg",
            width: 32,
            height: 32,
            alt: "arrow",
            wrapper: {
              className: "block w-full h-full pointer-events-none ".concat(index > 0 ? " transform rotate-180" : "")
            }
          })
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ListRegulation, {
      data: item.list_regulation
    })]
  });
};

var RegulationCardSlider = function RegulationCardSlider(_ref7) {
  var data = _ref7.data,
      dataOther = _ref7.dataOther,
      item = _ref7.item,
      index = _ref7.index;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: " flex h-full flex-col lg:mt-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "mb-6 flex ".concat(index > 0 ? "flex-row-reverse" : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: "text-2xl font-semibold leading-9 text-bbc-brand-700 ".concat(data.length > 1 ? "w-full lg:w-4/5 " : "w-full", " "),
        children: item.title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "",
      children: dataOther && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContentChildrenWithNote, {
        data: dataOther
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ListRegulation, {
      data: item.list_regulation
    })]
  });
};

var RightContent = function RightContent(_ref8) {
  var dataLeft = _ref8.dataLeft,
      dataRight = _ref8.dataRight;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("DESKTOP"),
      screen = _useState2[0],
      setScreen = _useState2[1];

  (0,common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(setScreen); // Const handleClickArrow = (e) => {
  //   Const getId = Number.parseInt(e.target.id.split("btn-")[1]);
  //   Document.getElementById(`company-${getId}`).classList.add("lg:hidden");
  //   Document.getElementById(`company-${1 - getId}`).classList.remove("lg:hidden");
  // }

  var swiper = {
    preloadImages: false,
    lazy: true,
    // Loop: true,
    allowTouchMove: false,
    navigation: {
      nextEl: ".slider-button-next",
      prevEl: ".slider-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 50
  };

  var RenderCard = function RenderCard(_ref9) {
    var dataRender = _ref9.dataRender;

    if (screen === "DESKTOP") {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, _objectSpread(_objectSpread({
        className: "shadow-bbc hidden h-full w-full rounded-xl bg-transparent !p-10 font-medium  text-bbc-gray lg:block lg:bg-white ",
        modules: [swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_]
      }, swiper), {}, {
        children: dataRender.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RegulationCard, {
              data: dataRender,
              item: item,
              index: index
            })
          }, index);
        })
      }));
    }

    if (Array.isArray(dataLeft) && Object.keys(dataLeft[0]).length > 0 && typeof dataLeft[0] !== "string") {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "block h-fit w-full space-y-6 rounded-xl bg-transparent py-0 px-4 text-bbc-brand-700 lg:hidden",
        children: dataRight.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RegulationCardSlider, {
              data: dataRight,
              dataOther: dataLeft[index],
              item: item,
              index: index
            })
          }, index);
        })
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "block h-fit w-full space-y-6 rounded-xl bg-transparent py-0 px-4 text-bbc-brand-700 lg:hidden",
      children: dataRight.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RegulationCard, {
            data: dataRight,
            item: item,
            index: index
          })
        }, index);
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RenderCard, {
    dataRender: dataRight
  });
};

var OffshoreCompanyRegistration = function OffshoreCompanyRegistration(_ref10) {
  var data = _ref10.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "lg:col-6",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(LeftContent, {
          data: data.data_left,
          description: data.data_top_left,
          title: data.country,
          dataJson: data
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "lg:col-6",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RightContent, {
          dataRight: data.data_right,
          dataLeft: data.data_left,
          description: data.data_top_left
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OffshoreCompanyRegistration);
OffshoreCompanyRegistration.defaultProps = {
  data: {},
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {})
};

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 58722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_WhatMakeUsDifferent; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(9846);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/Index.module.scss
var Index_module = __webpack_require__(81131);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/CardMakeDifferent.js







function CardMakeDifferent(_ref) {
  var title = _ref.title,
      description = _ref.description,
      src = _ref.src,
      alt = _ref.alt,
      rowReverse = _ref.rowReverse,
      listWithIcon = _ref.listWithIcon,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row justify-center ".concat(rowReverse && "flex-reverse" || ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      loading: "lazy",
      src: src,
      width: width || 540,
      height: height || 540,
      className: "h-auto w-full",
      wrapper: {
        className: "lg:col-6 flex items-center justify-center"
      },
      alt: alt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " justify-center lg:col-6 lg:flex lg:flex-col",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:pr-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h3",
          className: " mt-6 text-lg font-semibold text-bbc-brand-700 lg:mt-0 lg:text-bbc-30px",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-4 inline-block rounded-full lg:mt-6 ".concat((Index_module_default()).line, " ")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:text-normal mt-4",
          children: Array.isArray(description) ? description.map(function (item, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-semibold",
                children: item.content
              }), item.listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-2 mb-6",
                children: item.listWithIcon.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                    data: item
                  }, index);
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
            }, idx);
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [description, listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-3",
              children: listWithIcon.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                  data: item
                }, index);
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
          })
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/WMUDSlider.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var PostSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 4194).then(__webpack_require__.bind(__webpack_require__, 82385));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82385)];
    },
    modules: ["../components/organisms/WhatMakeUsDifferent/WMUDSlider.js -> " + "components/organisms/PostSlider"]
  }
});

var WMUDSlider = function WMUDSlider(_ref) {
  var data = _ref.data;
  var swiper = {
    direction: "vertical",
    preloadImages: false,
    lazy: true,
    autoHeight: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 800,
    fadeEffect: {
      crossFade: true
    },
    virtualTranslate: true,
    effect: "fade",
    mousewheel: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet block my-1",
      bulletActiveClass: "bbc-pagination-bullet-active h-10 w-2.5"
    },
    slidesPerView: "auto",
    spaceBetween: 0
  };

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container h-auto overflow-auto lg:h-[550px] lg:overflow-hidden",
    children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " relative ",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt, swiper_esm/* Mousewheel */.Gk, swiper_esm/* EffectFade */.xW]
      }, swiper), {}, {
        children: [Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: " flex text-left",
              style: {
                height: "550px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
                title: item.title,
                description: item.description,
                src: item.img_src,
                width: item.width,
                height: item.height,
                alt: item.img_alt,
                listWithIcon: item.listWithIcon
              })
            })
          }, index);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bbc-slide-pagination absolute right-0 z-10 -translate-y-1/2 pt-6",
          style: {
            top: "16rem"
          }
        })]
      }))
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider, {
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 50
        }
      },
      children: Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-full ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
              title: item.title,
              description: item.description,
              src: item.img_src,
              alt: item.img_alt,
              width: item.width,
              height: item.height,
              rowReverse: true,
              listWithIcon: item.listWithIcon
            })
          })
        }, index);
      })
    })
  });
};

/* harmony default export */ var WhatMakeUsDifferent_WMUDSlider = (WMUDSlider);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/index.js


var _excluded = ["data", "title", "ebookImage"];

function WhatMakeUsDifferent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function WhatMakeUsDifferent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WhatMakeUsDifferent_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WhatMakeUsDifferent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var WhatMakeUsDifferent = function WhatMakeUsDifferent(_ref) {
  var data = _ref.data,
      title = _ref.title,
      ebookImage = _ref.ebookImage,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", WhatMakeUsDifferent_objectSpread(WhatMakeUsDifferent_objectSpread({}, props), {}, {
    className: props.className || "bg-wmud py-12 ",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title mb-10 px-4 text-center lg:px-0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        classNamePrefix: "wmud-lazyload",
        placeholder: data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
            title: item.title,
            description: item.description,
            src: item.img_src,
            width: item.width,
            height: item.height,
            alt: item.img_alt,
            listWithIcon: item.listWithIcon
          }, index);
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent_WMUDSlider, {
          data: data,
          ebookImage: ebookImage
        })
      })
    })]
  }));
};

/* harmony default export */ var organisms_WhatMakeUsDifferent = (WhatMakeUsDifferent);

/***/ }),

/***/ 81131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"Index_line__t7vab"};

/***/ })

}]);